module.exports = __webpack_public_path__ + "assets/process4.f5cac6af.svg";